import { CodeWellDemo } from "./CodeWellDemo";
import { TextFaceDemo } from "./TextFaceDemo";
import { TextInkDemo } from "./TextInkDemo";

/*
 * Typography — <BeText>, the React face of `.be-pixel-text`.
 *
 * It is a component rather than only a class because a coverage run needs two
 * pairings that are easy to get wrong by hand and have both shipped as bugs: the
 * face's family and size are one decision, and an ink's colour and AA ramp are
 * another. See src/react/Text.tsx.
 */
export function Typography() {
	return (
		<section id="typography" className="demo-category">
			<h1>Typography</h1>
			<TextFaceDemo />
			<TextInkDemo />
			<CodeWellDemo />
		</section>
	);
}
